import {OrderCancellationReason} from '../dto/order-cancellation-reason';

export class OrderCancellationModel {
    public orderId: number;
    public cancellationReason: OrderCancellationReason;
    public cancellationComment: string;
}

